import React, { useContext, useState, useEffect } from 'react';
import './descriptionBox.css';
import { ShopContext } from '../../context/shopContext';
import ReviewWidget from '../reviewWidget/reviewWidget';

const DescriptionBox = ({ product }) => {
  const { allProducts } = useContext(ShopContext);
  const [activeTab, setActiveTab] = useState('description');
  const [reviewsLoaded, setReviewsLoaded] = useState(false);
  const [reviewCount, setReviewCount] = useState(0);

  // Find the product in the context if not provided via props
  const item = product || allProducts.find((item) => item.id === product?._id);

  // Effect to fetch reviews
  useEffect(() => {
    const checkReviews = () => {
      const reviewCountElement = document.querySelector('.trustspot-review-count');
      if (reviewCountElement) {
        const count = parseInt(reviewCountElement.innerText, 10);
        setReviewCount(count || 0);
      }
      setReviewsLoaded(true);
    };

    if (activeTab === 'reviews') {
      setReviewsLoaded(false);
      setTimeout(checkReviews, 500);
    }
  }, [activeTab, product?.id]);

  if (!item) {
    return <div>Loading product description...</div>;
  }

  return (
    <div className="description-box">
      <div className="description-box-nav">
        <div
          className={`description-box-nav-box ${activeTab === 'description' ? 'active' : ''}`}
          onClick={() => setActiveTab('description')}
        >
          Description
        </div>
        <div
          className={`description-box-nav-box ${activeTab === 'reviews' ? 'active' : ''}`}
          onClick={() => setActiveTab('reviews')}
        >
          Reviews (<span className="trustspot-review-count" data-product-sku={item.id}>{reviewCount}</span>)
        </div>
      </div>
      <div className="description-box-content">
        {activeTab === 'description' && (
          <div className="description-box-description">
            <p>{item?.longDescription || 'No description available.'}</p>
          </div>
        )}
        {activeTab === 'reviews' && (
          <div className="reviews-box">
            {reviewsLoaded ? (
              reviewCount > 0 ? (
                <ReviewWidget product={item} />
              ) : (
                <p>No reviews available for this product yet.</p>
              )
            ) : (
              <p>Loading reviews...</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DescriptionBox;
